module.exports = __webpack_public_path__ + "img/V31.ee8dda92.jpg";